// components
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";
import LetterCreateInner from "./LetterCreateInner";


class LetterCreateModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Добавление исходящего письма',
            modalIcon: TableViewIcon,
            mainComponent: LetterCreateInner,
            mainComponentProps: {
                opportunity: this.props.opportunity,
                account: this.props.account,
                contact: this.props.contact,
                lead: this.props.lead,
                callBack: this.process.bind(this)
            },
        }
    }

    async process(id){
        await this.props.callBack(id);
        this.setModalOpenFalse()
    }
}

export default LetterCreateModal
